<template>
  <div class="BaseNavigation_box" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave">
    <div class="BaseNavigation_title_box">
      {{ navItem.name }}
    </div>
    <div class="BaseNavigation_nav_box">
      <el-breadcrumb separator-class="el-icon-arrow-right cursor">
        <el-breadcrumb-item
          v-for="(item, index) in navItem.navList"
          :key="index + 'nav'"
          class="cursor"
          @click.native="goto(item)"
        >{{ item.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>

</template>
<script>
export default {
  name: 'BaseNavigation',
  props: {
    navItem: {
      type: Object,
      default: () => { }
    }

  },
  data() {
    return {}
  },
  methods: {
    goto(item) {
      if (item?.type === 'dlProcess') {
        this.$router.replace({
          path: '/judicialbusiness',
          query: {
            type: item.type
          }
        })
        return
      }
      this.$router.replace({
        path: `${this.navItem.routerUrl}/${item.type}`
      })
    },
    handleMouseOver() {
      this.$emit('changeNav', true)
    },
    handleMouseLeave() {
      this.$emit('changeNav', false, this.navItem)
    }
  }
}
</script>
<style lang="scss" scoped>
.BaseNavigation_box {
  position: fixed;
  left: 0;
  top: 60px;
  background-color: #fff;
  height: 80px;
  line-height: 80px;
  width: 100vw;
  box-shadow: 0px 4px 12px 0px rgba(20, 97, 191, 0.08);
  display: flex;
  align-items: center;

  .BaseNavigation_title_box {
    flex: 0 0 23%;
    height: 100%;
    background: #F8FBFF;
    text-align: right;
    padding-right: 60px;
  }

  .BaseNavigation_nav_box {
    min-width:500px;
    padding: 0 60px;

    ::v-deep {
      .el-breadcrumb__item {
        margin-right: 100px;

      }
      @media (max-width: 1100px) {
        .el-breadcrumb__item {
        margin-right: 20px;

      }
}

      .el-breadcrumb__item:hover {
        .is-link {
          color: #167FFF;
        }

        .el-icon-arrow-right {
          color: #167FFF;

        }
      }

      .el-breadcrumb__inner:hover {
        color: #167FFF !important;
      }

      .el-breadcrumb__inner {
        cursor: pointer !important;
      }

      .is-link {
        color: #1D2129;

        font-weight: 400;
        font-size: 16px;
      }

      .el-icon-arrow-right {
        color: #1D2129;
        font-size: 16px;
      }

      .el-breadcrumb__item:last-child .el-breadcrumb__separator,
      .el-menu--collapse>.el-menu-item .el-submenu__icon-arrow,
      .el-menu--collapse>.el-submenu>.el-submenu__title .el-submenu__icon-arrow {
        display: inline-block;
      }
    }
  }
}

</style>
